const OldValidationMixin = {
  methods: {
    /**
     * Convert Vuelidate property state into correct Vue Bootstrap 'state' value.
     * If the property is dirty and $error is true, then that means the validation failed in Vuelidate.
     * However, a state value of false indicates an error in Vue Bootstrap, so it needs to be converted.
     *
     * Additionally, we should (for now?) avoid returning a value of true here, as that will
     * result in Bootstrap showing a 'is-valid' state, which means the inputs will turn green.
     * We don't have green CSS for all our inputs, so this will end up being inconsistent.
     *
     * I don't necessarily like showing green either - once you press the submit button, you can
     * assume a form is valid once it stops being red.
     *
     * @param property
     * @returns {*}
     */
    validationState (property) {
      if (property.$dirty === true && property.$error === true) {
        return false
      }
      return null
    },
    /**
     * Normally, for most bootstrap-vue components, we can set the 'state' property using validationState,
     * but we may not always have it available for third party components (such as multiselect)
     *
     * This method will return the correct 'is-invalid' class state for a vuelidate property.
     *
     * @param property
     * @returns {{"is-invalid": (*|null)}}
     */
    getStateClass (property) {
      return {
        'is-invalid': property.$dirty ? property.$error : null
      }
    }
  }
}
export default OldValidationMixin
